import { Button } from "semantic-ui-react";
import styled from "styled-components";

export const BorderlessButton = styled(Button)`
  &&&&& {
    border: 0;
    font-weight: bold;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    &:focus {
      outline: 1px solid #007ac6;
    }
  }
`;
